import { SwapOutlined } from '@ant-design/icons'
import { Horizontal, Texto } from '@gravitate-js/excalibrr'
import { Button, Select, Tooltip } from 'antd'
import React from 'react'
import { TenantSelectorProps } from '../types'

/**
 * Tenant selector controls for the three-way mapping view
 */
export const TenantSelector: React.FC<TenantSelectorProps> = ({
  leftTenant,
  rightTenant,
  tenants,
  onLeftTenantChange,
  onRightTenantChange,
  onSwapTenants,
}) => {
  return (
    <Horizontal gap={12} verticalCenter>
      <Horizontal gap={8} verticalCenter>
        <Texto>Left:</Texto>
        <Select
          value={leftTenant}
          onChange={onLeftTenantChange}
          style={{ width: 140 }}
          placeholder='Select tenant'
          options={tenants.map((t) => ({ value: t.name, label: t.name }))}
        />
      </Horizontal>

      <Tooltip title='Swap tenants'>
        <Button
          icon={<SwapOutlined />}
          onClick={onSwapTenants}
          disabled={leftTenant === 'none' || rightTenant === 'none'}
          type='text'
        />
      </Tooltip>

      <Horizontal gap={8} verticalCenter>
        <Texto>Right:</Texto>
        <Select
          value={rightTenant}
          onChange={onRightTenantChange}
          style={{ width: 140 }}
          placeholder='Select tenant'
          options={tenants.map((t) => ({ value: t.name, label: t.name }))}
        />
      </Horizontal>
    </Horizontal>
  )
}
